export default __webpack_public_path__ + "static/media/BC_444_BC_07235.ec8d90e4.jpg";